<template>
    <div class="flex justify-center items-center">
        <div class="w-full max-w-sm px-2">

            <h1 class="text-center text-azuloscuro text-xl font-semibold mt-20 mb-5">

            </h1>

            <div class="w-full mb-4 self-center px-8">
                <img src="@/assets/images/pill_error_image.png"
                class="w-full self-center" />
            </div>

            <div>
                <p class="text-center text-azuloscuro font-semibold text-lg mx-16">
                    Con la prisa olvidaste terminar el test.
                </p>
            </div>

            <div class="mt-20">

                    <button @click="goBackToPill(i.pill.contentType, i, idx)" class="bg-azuloscuro hover:bg-greenlight hover:text-white text-white pt-2 pb-0 px-4 rounded-full focus:outline-none w-full"
                    type="button">
                        <div class="flex justify-left mb-2 px-4">

                            <div class="pt-1">
                                <Zondicon icon="arrow-thin-left" class="fill-current inline-block h-4 line"/>
                            </div>

                            <div class="font-semibold text-center w-full pt-1">
                                Volver para terminarlo
                            </div>
                        </div>
                    </button>

            </div>

            <div class="mt-5 text-center">
                <router-link
                    to="/"
                    class="inline-block self-center text-sm text-blue-500 hover:text-blue-800">
                    Terminar más tarde
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
    import Utilities from '@/plugins/Utilities.js'
    import Zondicon from 'vue-zondicons'
    import setTitle from "../plugins/title";

    const PillsError = {
        name: 'PillsIncomplete',
        layout: '',
        components: {
            Zondicon
        },
        data: function(){
            return {

            }
        },
        beforeMount: function(){
            if(!Utilities.isLogged()){
                this.$router.push({ name:'login' })
            }
            this.i = this.$route.params.i;
            this.idx = this.$route.params.idx;

        },
        methods: {
            goBackToPill: function(tipo, i, idx){
                if(tipo == '0'){
                    this.$router.push({ name:'pills_video' , params: { i, idx, test: this.$route.params.test }})
                }

                if(tipo == '1'){
                    this.$router.push({ name:'pills_pdf', params: { i, idx, test: this.$route.params.test } })
                }

                if(tipo == '2'){
                    this.$router.push({ name:'pills_audio', params: { i, idx, test: this.$route.params.test } })
                }
                if(tipo == '3'){
                    this.$router.push({ name:'pills_text', params: { i, idx, test: this.$route.params.test } })
                }

               if(tipo == '4'){
                    this.$router.push({ name:'pills_image', params: { i, idx, test: this.$route.params.test } })
                }
            }
        },
        created () {
            setTitle('¡Casi!')
        }
    }

    export default PillsError;
</script>
